import axios from "../../axiosConfig/axios";

export const marketplace = {
    async addSoutions(data) {
        console.log(data)
        return axios.patch(`users/${data?.type}`,
            {
                solution: data?.solution
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': data?.token
                }
            })
    }
}
